import { AddressDeliveryType } from "../../../models/transportation/enums/addressDeliveryType";
import { JsonProperty } from "../../../models/utilities/json-property";
import { ValidateProperty } from "../../../models/utilities/validate-property";

export class ShipToAddressApprove {
    
    public rowVersion : string = '';

    @ValidateProperty({ required: true })
    public unloadRate : number|undefined = undefined;
    
    @ValidateProperty({ required: true })
    public latitude : number|null = null;
    
    @ValidateProperty({ required: true })
    public longitude : number|null = null;
    
    @ValidateProperty({ required: true })
    public timeZoneId : string = '';
    
    @ValidateProperty({ required: true })
    public country : string = '';

    @ValidateProperty({ minChildren: 1 })
    public deliveryHours: DeliveryHourUpdate[] = [];

    public phoneNumber: string | null = null;

    public contactEmailBusiness: string | null = null;

    public contactNameBusiness: string | null = null;

    public contactPhoneNumberBusiness: string | null = null;

    public contactEmailSite: string | null = null;

    public contactNameSite: string | null = null;

    public contactPhoneNumberSite: string | null = null;

    public note: string | null = null;

    public isJobSite: boolean = false;

    public force: boolean = false;

    @ValidateProperty({ required: true })
    public name: string | null = null;

    @ValidateProperty({ required: true })
    public addressLine1: string | null = null;

    public addressLine2: string | null = null;

    @ValidateProperty({ required: true })
    public city: string | null = null;

    @ValidateProperty({ required: true })
    public stateProvince: string | null = null;

    @ValidateProperty({ required: true })
    public postalCode: string | null = null;

    public isReviewed: boolean = false;

    public deliveryTypes: AddressDeliveryType[] = [];
}

export class DeliveryHourUpdate {

    public weekDays: number;

    public startTime: string = '';

    public endTime?: string = '';

}

export class ApproveAddress {

    public addressLine1     : string | null = null;
    
    public addressLine2     : string | null = null;
    
    public city             : string | null = null;
    
    public stateProvince    : string | null = null;
    
    public postalCode       : string | null = null;
    
    public country          : string | null = null;
    
    public latitude         : number | null = null;
    
    public longitude        : number | null = null;
    
    public timeZoneId       : string = '';
}

export enum AddressApproveStatus {
    Unknown = 0,
    Success = 1,
    NotApprovedGoogleHasSuggestion = 2,
    NotApprovedGoogleNotFound = 3
}

export class DeliveryAddressApproveResponse {
    
    public shipToAddressId: number | null = null;

    @JsonProperty({ toClass: ApproveAddress })
    public suggestedAddress: ApproveAddress = new ApproveAddress();

    public status: AddressApproveStatus = AddressApproveStatus.Unknown;
}